import { render, staticRenderFns } from "./totalContrast.vue?vue&type=template&id=f4baf7c6&scoped=true"
import script from "./totalContrast.vue?vue&type=script&lang=js"
export * from "./totalContrast.vue?vue&type=script&lang=js"
import style0 from "./totalContrast.vue?vue&type=style&index=0&id=f4baf7c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4baf7c6",
  null
  
)

export default component.exports